<form class="form-container" [formGroup]="form">
    <h2 mat-dialog-title>{{'WORK_FLOW_STEPS' | translate}}</h2>
    <mat-dialog-content class="mat-typography">
        <mat-form-field appearance="outline">
            <mat-label>{{'WORK_FLOW_STEP_NAME' | translate}} </mat-label>
            <input matInput formControlName="name">
            @if (f['name'].errors) {
            <mat-error>
                @if (f['name'].errors['required']) { <span>{{'WORK_FLOW_STEP_NAME_REQUIRED' | translate}}</span>}
                @if (f['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'DESCRIPTION' | translate}} </mat-label>
            <input matInput formControlName="description">
            @if (f['description'].errors) {
            <mat-error>
                @if (f['description'].errors['required']) { <span>{{'DESCRIPTION_REQUIRED' | translate}}</span>}
                @if (f['description'].errors['maxlength']) { <span>{{'MAX_LENGTH_300' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline" >
            <mat-label>{{'PROCESS_TYPE' | translate}} </mat-label>
            <mat-select formControlName="processType" (selectionChange)="onProcessTypeSelect()">
                @for (p of processStepKeys;track p) {
                <mat-option [value]="p">{{p | processPipe}}</mat-option>
                }
            </mat-select>
            @if (f['processType'].errors) {
                <mat-error>
                    @if (f['processType'].errors['defaultProcessExist']) { <span>{{'ONLY_ONE_DEFAULT_PROCESS_ALLOWED' | translate}}</span>}
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'PREDESESSOR' | translate}} </mat-label>
            <mat-select formControlName="predecessorProcessId" multiple>
                @for (step of processSteps;track step) {
                <mat-option [value]="step.complaintProcessId">{{step.name}}</mat-option>
                }
            </mat-select>
            <!-- <mat-select formControlName="predecessorProcessId" multiple>
                  <input id="search-predecessor" class="w-100 border-0 p-1" (input)="filteredListprocessSteps=onFilteredListSearch($event, processSteps, 'name')"
                  placeholder="Search {{ 'COMPLAINT_TYPE' | translate }}" />
                @for (step of filteredListprocessSteps;track step) {
                <mat-option [value]="step.complaintProcessId">{{step.name}}</mat-option>
                }
            </mat-select> -->
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'SUCCESSOR' | translate}} </mat-label>
            <mat-select formControlName="successorProcessId" multiple>
                @for (step of processSteps;track step) {
                <mat-option [value]="step.complaintProcessId">{{step.name}}</mat-option>
                }
            </mat-select>
            <!-- <mat-select formControlName="successorProcessId" multiple >
                  <input id="search-successor" class="w-100 border-0 p-1" (input)="filteredListprocessSteps=onFilteredListSearch($event, processSteps, 'name')"
                  placeholder="Search {{ 'COMPLAINT_TYPE' | translate }}" />
                @for (step of filteredListprocessSteps;track step) {
                <mat-option [value]="step.complaintProcessId">{{step.name}}</mat-option>
                }
            </mat-select> -->
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (f['complaintProcessId'].value != null) {
        <button mat-button class="btn-primary" [disabled]="form.invalid" (click)="edit()" color="primary"
            cdkFocusInitial>{{'Save' |
            translate}} </button>
        } @else {
        <button mat-button class="btn-primary" [disabled]="form.invalid" (click)="add()" color="primary"
            cdkFocusInitial>{{'Add_BUTTON'
            | translate}} </button>
        }
        <button mat-button class="btn-secondary" mat-dialog-close>{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</form>